/**
 * Authors: mariushirjanu
 * Created: 06/11/2023
 */
import { Injectable } from '@angular/core';

import { HttpDataService } from '../../../shared/http/http-data.service';
import { ICodeValue, IContact } from '../../../../type_definitions/datatypes';

export interface IWebshopB2BSettingsData {
  numOrdersThisYear:number;
  numOrdersPreviousYear:number;
  revenueThisYear:number;
  revenuePreviousYear:number;
  priceSentInXmlFiles:string;
  defaultB2bContact:IContact;
  orderProcess:ICodeValue;
  emailOrders:boolean;
  emailOrdersCharge:number;
  processNonCatalogOrderType:ICodeValue;
  cxmlShowTaxDetailInSummary:boolean;
}

@Injectable()
export class WebshopB2BSettingsDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /***/
  }

  public getWebshopB2BSettings(webshopId:number):Promise<IWebshopB2BSettingsData> {
    return this.httpDataService.doGET(
      `rest/webshops/${webshopId}/b2bsettings`,
      {},
      undefined,
      'Error loading B2B settings'
    );
  }

  public saveWebshopB2BSettings(webshopId:number, data:IWebshopB2BSettingsData):Promise<IWebshopB2BSettingsData> {
    return this.httpDataService.doPUT(
      `rest/webshops/${webshopId}/b2bsettings`,
      undefined,
      data,
      'Saving webshop B2B settings',
      'Error saving B2B settings'
    );
  }

  public getB2BSettingsContacts(webshopId:number, filter?:string):Promise<IContact[]> {
    return this.httpDataService.doGET(
      `rest/webshops/${webshopId}/b2bsettings/contacts`,
      { filter },
      undefined,
      'Error loading contacts'
    );
  }
}